<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { inputProps } from './input'

defineOptions({
  name: 'VsInput',
})

const props = defineProps(inputProps)

// init here
</script>
